import { NoData } from "@similarweb/icons";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

export const MarketingChannelsLobNoData = () => {
    return (
        <Stack
            data-automation="marketing-channels-lob-no-data"
            alignItems="center"
            justifyContent="center"
            minHeight="400px"
            width="100%"
            gap="32px"
        >
            <NoData size={90} />
            <Text fontVariant="body2">{translate("industry.trafficsources.lob.notavailable")}</Text>
        </Stack>
    );
};
